import React, { useEffect, useRef } from 'react'
import { DebounceInput } from 'react-debounce-input'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import useSavedSearch from 'helpers/useSavedSearch'
import { findGroupParentBarcode } from 'helpers/productGroup'

function FilterSearch({ filterData, setFilterData, reduxFilterSearch, disableGroupSearch = false }) {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)

	// Sozlamada yoqilgan bo'lsa, yozilgan matn saqlanadi va sahifaga qaytilganda tiklanadi.
	const saveSearch = useSavedSearch((value) => requestToServer(value))

	async function requestToServer(value) {
		if (value.length !== 0 && value.length <= 2) return;
		saveSearch(value)

		// Guruhlangan tovarning a'zo (bola) shtrix-kodi yozilgan bo'lsa, ro'yxatlarda
		// faqat bosh tovar bor -- qidiruvni o'sha bosh tovar shtrix-kodiga almashtiramiz.
		//
		// Hisobotlarda (savdo, qoldiq, qaytarilgan ...) esa a'zo tovarning o'z qatorlari
		// bo'ladi, shuning uchun u yerda almashtirish O'CHIRILADI -- `disableGroupSearch`.
		let searchValue = value
		if (!disableGroupSearch) {
			const parentBarcode = await findGroupParentBarcode(filterData?.posId || reduxAccount?.posId, value)
			if (parentBarcode) {
				searchValue = parentBarcode
				toast.info(`${t('GROUPED_PRODUCT_SEARCHED_BY_PARENT')}: ${parentBarcode}`)
			}
		}

		// Saqlangan matn tiklanayotganda filterData eskirgan bo'lmasligi uchun funksiya orqali yangilanadi.
		if (reduxFilterSearch) {
			setFilterData(prev => ({ ...prev, 'search': searchValue, 'random': prev?.random + 1 }))
			return;
		}
		setFilterData(prev => ({ ...prev, 'search': searchValue }))
	};
	const searchRef = useRef(null);

	useEffect(() => {
		const handleKeyPress = (e) => {
			if (e.key == "Control") return;
			// Ctrl/Cmd/Alt bosilganda fokusni o'g'irlamaymiz (Ctrl+C, Ctrl+V, Ctrl+A ishlashi uchun)
			if (e.ctrlKey || e.metaKey || e.altKey) return;
			const active = document.activeElement;
			const isEditable =
				active &&
				(active.tagName === "INPUT" || active.tagName === "TEXTAREA") &&
				!active.disabled &&
				!active.readOnly;

			if (!isEditable) {
				// Agar hech qanday input fokusda bo'lmasa
				searchRef.current.focus();
			}
		};

		document.addEventListener("keydown", handleKeyPress);

		return () => {
			document.removeEventListener("keydown", handleKeyPress);
		};
	}, []);

	return (
		<div className="position-relative me-2">
			<i className="uil-search input-search-icon"></i>
			<DebounceInput
				value={filterData.search}
				type="text"
				inputRef={searchRef}
				className="form-control"
				placeholder={t('SEARCH') + '...'}
				minLength={3}
				debounceTimeout={1000}
				onChange={(e) => requestToServer(e.target.value)}
				onKeyUp={(e) => {
					if (e.keyCode === 13) {
						requestToServer(e.target.value)
					}
				}}
			/>
		</div>
	)
}

export default FilterSearch
